/**
 * Clear Key UUID.
 *
 * @group DRM
 *
 * @beta
 */
export const CLEAR_KEY_UUID = 'e2719d58-a985-b3c9-781a-b030af78d30e';
